export const calculateDtw = (json) => {
  const distance1_L = [];
  const distance2_L = [];
  const ratio_L = [];

  json.original_data.forEach((s) => {
    distance1_L.push(s.dtw_distance1);
    distance2_L.push(s.dtw_distance2);
    ratio_L.push(s.dtw_distance1 == 0 ? 0 : s.dtw_distance2 / s.dtw_distance1);
  });

  const distance1_R = calculateStatistics(distance1_L);
  const distance2_R = calculateStatistics(distance2_L);
  const ratio_R = calculateStatistics(ratio_L);

  const ret = {
    dtw1_mean: distance1_R[0], 
    dtw1_median: distance1_R[1], 
    dtw1_sd: distance1_R[2], 
    dtw1_se: distance1_R[3], 
    dtw1_cv: distance1_R[4], 

    dtw2_mean: distance2_R[0], 
    dtw2_median: distance2_R[1], 
    dtw2_sd: distance2_R[2], 
    dtw2_se: distance2_R[3], 
    dtw2_cv: distance2_R[4], 

    dtw_ratio_mean: ratio_R[0], 
    dtw_ratio_median: ratio_R[1], 
    dtw_ratio_sd: ratio_R[2], 
    dtw_ratio_se: ratio_R[3], 
    dtw_ratio_cv: ratio_R[4], 

    dtw_judge1: ratio_L.reduce((sum, val) => sum + (val > 1 ? 1 : 0), 0),
    dtw_judge2: ratio_L.reduce((sum, val) => sum + (val <= 1 ? 1 : 0), 0)
  };

  ret['dtw_judge1_per'] = 
    json.summary_data.vocab_count == 0 ? 0 :
    (ret.dtw_judge1 / json.summary_data.vocab_count) * 100

  return ret;
}


const calculateStatistics = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return [0, 0, 0, 0, 0];
  }

  // 平均値
  const mean = arr.reduce((sum, val) => sum + val, 0) / arr.length;

  // 中央値
  const sorted = [...arr].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  const median =
    sorted.length % 2 === 0
      ? (sorted[middle - 1] + sorted[middle]) / 2
      : sorted[middle];

  // 分散
  const variance =
    arr.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / arr.length;

  // 標準偏差
  const standardDeviation = Math.sqrt(variance);

  // 標準誤差
  const standardError = standardDeviation / Math.sqrt(arr.length);

  //変動係数
  const cv = mean == 0 ? 0 : standardDeviation / mean;
  return [mean, median, standardDeviation, standardError, cv];
}
